import { proxy } from 'valtio';

import type { Theme } from '@canvas/constants/ui/theme';

export const defaultTheme: Theme = 'light';

export const currentThemeState: { theme: Theme } = proxy({
  theme: 'light',
});
